import { useState } from "react";
import { ChangePassword, compilePositionsForMe } from "../../api";
import { useAtom, useAtomValue } from "jotai";
import { AccountAtom, AppStateAtom } from "../../store";
import { useToast } from "@chakra-ui/react";
import { getStripePortal } from "../../api";
import { track, EVENTS } from "../../utils/analytics";
import { useNotifications } from "../../hooks/useNotifications";

interface SettingsController {
  password: string;
  changePassword: () => void;
  requestStripePortal: () => void;
  setPassword: (password: string) => void;
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  loading: boolean;
  errorMessage: string;
  logout: () => void;
  rebuildPositions: () => void;
}

export const useSettingsController = () => {
  const accountState = useAtomValue(AccountAtom);
  const [password, setPassword] = useState<string>("");
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const toast = useToast();
  const notifications = useNotifications();

  const performPasswordChange = async () => {
    track(EVENTS.SETTINGS.CHANGE_PASSWORD_ATTEMPT);

    setLoading(true);

    ChangePassword(password).then((res) => {
      setTimeout(() => {
        if (res.success === true) {
          console.log("Password changed successfully");

          notifications.createNotification(
            "Password changed successfully",
            "success",
          );

          setTimeout(() => {
            notifications.clearNotifications();
          }, 2000);

          setErrorMessage("");
          setPassword("");
          setDrawerOpen(false);
        } else {
          console.log("Error changing password");
          toast({
            title: "Error changing password",
            description: res.msg,
            status: "error",
            duration: 9000,
            isClosable: true,
          });

          notifications.createNotification("Error changing password", "error");

          setTimeout(() => {
            notifications.clearNotifications();
          }, 5000);
          setErrorMessage(res.msg);
        }
        setLoading(false);
      }, 200);
    });
  };

  const reqStripePortal = () => {
    track(EVENTS.SUBSCRIPTION.REQUEST_PORTAL);
    setLoading(true);
    getStripePortal().then((res) => {
      if (res.success === true) {
        window.location.href = res.url;
      }
      setLoading(false);
    });
  };

  const rebuildPositions = async () => {
    await compilePositionsForMe(accountState?.selectedAccount?.id);
    toast({
      title: "Positions Rebuilt",
      description: "Hit F5 to refresh data.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  const handleLogout = () => {
    window.localStorage.removeItem("token");
    window.location.href = "../app/login";
  };

  return {
    password: "",
    changePassword: performPasswordChange,
    setPassword,
    requestStripePortal: reqStripePortal,
    drawerOpen,
    setDrawerOpen,
    loading,
    errorMessage,
    logout: handleLogout,
    rebuildPositions,
  } as SettingsController;
};
